import React from "react";
import PropTypes from "prop-types";
import { formatDate } from "utils/dates";
import { Ul, AttributeItem } from "components/lists";
import DayPicker from "react-day-picker";
import CalenderControls from "components/ui/date-picker/calender-controls";
import HasRolePermission from "components/shared/has-role-permission";
import { updatePatientOutreachDate } from "actions/patient";
import { useDispatch } from "react-redux";

const OutrachDates = ({
  patientInfo,
  product_line,
  override_outreach_date,
  outreach_date,
  outreach_cycle,
  patientId,
  readOnly
}) => {
  const [calenderIsOpen, setCalenderIsOpen] = React.useState();
  const dispatch = useDispatch();

  return (
    <Ul>
      <AttributeItem title="Outreach Date">
        {formatDate(outreach_date, "MM/DD/YYYY")}
      </AttributeItem>
      <AttributeItem title="Outreach Cycle">{outreach_cycle}</AttributeItem>
      {/* <AttributeItem title="Override Outreach Date:"> */}
      {/*   <div className="overide-date-checkbox-container"> */}
      {/*     <input */}
      {/*       type="checkbox" */}
      {/*       checked={override_outreach_date || false} */}
      {/*       disabled={readOnly || !patientInfo.active} */}
      {/*       onChange={({ target: { checked } }) => { */}
      {/*         dispatch( */}
      {/*           updatePatientOutreachDate(patientId, { */}
      {/*             product_line, */}
      {/*             override_outreach_date: checked */}
      {/*           }) */}
      {/*         ); */}
      {/*       }} */}
      {/*     /> */}
      {/*   </div> */}
      {/* </AttributeItem> */}

      {!override_outreach_date && (
        <React.Fragment>
          <div className="patient-outreach-date-controls">
            <HasRolePermission
              allowedRoles={[
                "Administrator",
                "SleepCoach",
                "ServiceCoach",
                "ServiceAdmin",
                "ContractorAdministrator"
              ]}
            >
              <button
                className="button secondary icon-button"
                disabled={readOnly || !patientInfo.active}
                onClick={() => {
                  dispatch(
                    updatePatientOutreachDate(patientId, {
                      product_line,
                      auto_push: true
                      //overrideEligibilityDate: checked
                    })
                  );
                }}
              >
                Push Outreach
              </button>
            </HasRolePermission>
            <button
              className="button secondary icon-button"
              disabled={readOnly || !patientInfo.active}
              onClick={() => setCalenderIsOpen(true)}
            >
              Push Outreach Manual
            </button>
          </div>
          <div className="date-picker container">
            {calenderIsOpen && (
              <div id={"datePicker"} className="entryContainer">
                <div
                  className="outOfBounds"
                  onClick={() => setCalenderIsOpen(false)}
                />
                <div className="pickerContainer">
                  <DayPicker
                    onDayClick={day => {
                      if (!day) return;
                      const date = formatDate(day, "yyyy-MM-DD");
                      setCalenderIsOpen(false);

                      dispatch(
                        updatePatientOutreachDate(patientId, {
                          outreach_date: date,
                          product_line,
                          update_forms: false
                        })
                      );
                    }}
                    containerProps={{ style: { padding: 0 } }}
                    selectedDay={outreach_date}
                  />
                  <CalenderControls
                    handleDayChange={day => {
                      if (!day) return;
                      const date = formatDate(day, "yyyy-MM-DD");
                      setCalenderIsOpen(false);
                      dispatch(
                        updatePatientOutreachDate(patientId, {
                          outreach_date: date,
                          product_line,
                          update_forms: false
                        })
                      );
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </React.Fragment>
      )}
    </Ul>
  );
};

OutrachDates.propTypes = {
  patientId: PropTypes.string.isRequired,
  product_line: PropTypes.string.isRequired,
  patientInfo: PropTypes.object.isRequired,
  outreach_date: PropTypes.string,
  outreach_cycle: PropTypes.number.isRequired,
  override_outreach_date: PropTypes.bool,
  readOnly: PropTypes.bool.isRequired
};

OutrachDates.defaultProps = {
  readOnly: false
};

export default OutrachDates;
